import { OnInit, Component } from "@angular/core";
import { BaseService } from "src/app/Services/Base.service";
declare var $: any;


@Component({
  selector: "app-about",
  templateUrl: "./about.component.html",
  styleUrls: ["./about.component.scss"]
})

export class AboutComponent implements OnInit {
  lang: string;

  constructor(private base: BaseService) { }

  ngOnInit() {
    this.lang = this.base.getLang();
    $(document).ready(function () {
      var body = $("html, body");
      body.stop().animate({ scrollTop: 0 }, 500, "swing");
      $(".nav-item").removeClass("active");
      $("#about").addClass("active");
    });
  }

  ngAfterContentChecked(): void {
    this.lang = this.base.getLang();
  }

  
  onLoading(id) {
    $("#" + id).fadeOut("slow");
  }
}
